import { Injectable } from '@nestjs/common';
import { HsnCodes } from '../hsn-codes.entity';
import { HsnCodesDTO } from './hsn-codes.dto';

@Injectable()
export class HsnCodesAdapter {
 
    /**
     * 
     * @param hsnCodesDTO 
     * @param hsnUpdate 
     */
  public convertDtoToEntity(hsnCodesDTO: HsnCodesDTO,  hsnUpdate: boolean = false ): HsnCodes {
 
    const hsnCodes = new HsnCodes();
    hsnCodes.hsnCodeId=hsnCodesDTO.hsnCodeId;
    hsnCodes.hsnCode=hsnCodesDTO.hsnCode;
    hsnCodes.productId=hsnCodesDTO.productId;
    hsnCodes.foodTypeId=hsnCodesDTO.foodTypeId;
    hsnCodes.valueAdditionOneId=hsnCodesDTO.valueAdditionOneId;
    hsnCodes.valueAdditionTwoId=hsnCodesDTO.valueAdditionTwoId;
    hsnCodes.valueAdditionThreeId=hsnCodesDTO.valueAdditionThreeId;
    hsnCodes.valueAdditionFourId=hsnCodesDTO.valueAdditionFourId;
    hsnCodes.valueAdditionFiveId=hsnCodesDTO.valueAdditionFiveId;
    hsnCodes.variantCode=hsnCodesDTO.variantCode;
   
    hsnCodes.isActive=hsnCodesDTO.isActive==undefined?true:hsnCodesDTO.isActive;
    if (hsnUpdate) {
      hsnCodes.updatedUser = hsnCodesDTO.updatedUser;
    } else {
      hsnCodes.isActive = true;
      hsnCodes.createdUser = hsnCodesDTO.createdUser;
    }
   return hsnCodes;
  }
  public convertEntityToDto(hsnCodesObject: HsnCodes): HsnCodesDTO {
    const hsnCodesDTO= new HsnCodesDTO;
    hsnCodesDTO.hsnCodeId=hsnCodesObject.hsnCodeId;
    hsnCodesDTO.hsnCode=hsnCodesObject.hsnCode;
    hsnCodesDTO.productId=hsnCodesObject.productId
    hsnCodesDTO.foodTypeId=hsnCodesObject.foodTypeId;
    hsnCodesDTO.valueAdditionOneId=hsnCodesObject.valueAdditionOneId;
    hsnCodesDTO.valueAdditionTwoId=hsnCodesObject.valueAdditionTwoId;
    hsnCodesDTO.valueAdditionThreeId=hsnCodesObject.valueAdditionThreeId;
    hsnCodesDTO.valueAdditionFourId=hsnCodesObject.valueAdditionFourId;
    hsnCodesDTO.valueAdditionFiveId=hsnCodesObject.valueAdditionFiveId;
    hsnCodesDTO.variantCode=hsnCodesObject.variantCode;
    hsnCodesDTO.isActive = hsnCodesObject.isActive;
    hsnCodesDTO.createdAt = hsnCodesObject.createdAt;
    hsnCodesDTO.updatedAt = hsnCodesObject.updatedAt;
    hsnCodesDTO.createdUser = hsnCodesObject.createdUser;
    hsnCodesDTO.updatedUser = hsnCodesObject.updatedUser;
    hsnCodesDTO.versionFlag = hsnCodesObject.versionFlag;
    return hsnCodesDTO;
  }
}
